import React, { useState, useEffect } from 'react'

interface Props {
  targetDate: Date
}

const Countdown = ({ targetDate }: Props) => {
  const calculateTimeLeft = (): number => {
    const now = new Date().getTime()
    const timeToExpire = targetDate.getTime() - now
    return timeToExpire
  }

  function msToMinutesSeconds(ms: number): string {
    const minutes = Math.floor(ms / 60000)
    const seconds = Math.floor((ms % 60000) / 1000)

    return `${minutes}:${seconds.toString().padStart(2, '0')}`
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)

    // Cleanup the timer
    return () => clearTimeout(timer)
  }, [timeLeft])

  return <span>{timeLeft < 0 ? 'Expired' : msToMinutesSeconds(timeLeft)}</span>
}

export default Countdown
